export const firebaseConfig = {
  apiKey: "AIzaSyBlrpSSbB2ToFNS1U_1QYEFRyXbmyO_5fM",
  authDomain: "typerunner.firebaseapp.com",
  projectId: "typerunner",
  storageBucket: "typerunner.appspot.com",
  messagingSenderId: "1095900056954",
  appId: "1:1095900056954:web:d4fec7ac2caf8614d49ac3",
  measurementId: "G-E0MBD0XQ01",
};
